export default __webpack_public_path__ + "static/media/AIC LOGO NAVBAR.68327634.svg";